import React from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import CustomScroll from "react-custom-scroll";

import { defaultResponsiveDashboardLayout } from "../../constants/defaultDashboardConfig";

import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

const ResponsiveGridLayout = WidthProvider(Responsive);

const Dashboard = (props) => {
  const { height = 50 } = props;
  return (
    <div className="dashboard-container">
      <CustomScroll
        heightRelativeToParent="100%"
        allowOuterScroll={true}
        keepAtBottom={true}
      >
        <ResponsiveGridLayout
          className="layout gridLayout"
          layouts={defaultResponsiveDashboardLayout}
          breakpoints={{ lg: 1200 }}
          cols={{ lg: 12 }}
          measureBeforeMount={false}
          margin={[20, 20]}
          rowHeight={height}
          useCSSTransforms={true}
          isResizable={false}
          isDraggable={true}
        >
          {props.children}
        </ResponsiveGridLayout>
      </CustomScroll>
    </div>
  );
};

export default Dashboard;
